module.exports = __webpack_public_path__ + "static/media/10.3b0a1836.jpg";